import * as service from '../../services'

export const generalItems = async () => {
  const familyAll = await service.getFamilyAll()
  const specieAll = await service.getSpecieAll()
  const parishAll = await service.getParishAll()
  const siteNameAll = await service.getSiteNameAll()
  const pseudonymAll = await service.getPseudonymAll()
  const siteSectionAll = await service.getSiteSectionAll()
  const siteSiteAcronymAll = await service.getSiteAcronymAll()

  return [
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'family_',
      initvalue: '',
      label: 'Familia',
      options: familyAll,
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'specie_',
      initvalue: '',
      label: 'Especie',
      options: specieAll,
    },
    {
      x: 12,
      s: 12,
      m: 6,
      name: `pseudonym_`,
      data: [],
      options: pseudonymAll,
      label: 'Nombre común',
      variant: 'standard',
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'parish_',
      initvalue: '',
      label: 'Parroquia',
      options: parishAll,
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'typeSite_',
      initvalue: '#',
      label: 'Tipo de sitio',
      options: {
        '#': 'No definido',
        Avenida: 'Avenida',
        Parque: 'Parque',
        'Campus UNL': 'Campus UNL',
      },
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'site_',
      initvalue: '',
      label: 'Sitio',
      multiline: true,
      align: 'center',
      options: siteNameAll,
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'siteAcronym_',
      initvalue: '',
      label: 'Acronimo de Ubicación',
      multiline: true,
      align: 'center',
      options: siteSiteAcronymAll,
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'section_',
      initvalue: '',
      label: 'Sección',
      multiline: true,
      align: 'center',
      options: siteSectionAll,
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'alive_',
      initvalue: 1,
      label: 'Estado actual',
      options: { 0: 'Muerto', 1: 'Vivo' },
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'treeVerified_',
      initvalue: 0,
      label: 'Estado de registro',
      options: { 0: 'No verificado', 1: 'Verificado' },
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'recorded_',
      initvalue: '',
      label: 'Nombre del colector',
      multiline: true,
      align: 'center',
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'commit_',
      initvalue: '',
      label: 'Comentario',
      multiline: true,
      align: 'start',
    },
  ]
}
